export default {
  getCookie(name) {
    var arr = document.cookie.replace(/\s/g, '').split('&')
    for (var i = 0; i < arr.length; i++) {
      var tempArr = arr[i].split('=')
      if (tempArr[0] === name) {
        return decodeURIComponent(tempArr[1])
      }
    }
    return ''
  },
  setCookie(name, value, minute) {
    var exp = new Date()
    exp.setTime(exp.getTime() + minute * 1000 * 60)
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      exp.toGMTString() +
      window.$global.DoMain
  },
  delCookie(name) {
    // 设置已过期，系统会立刻删除cookie
    this.setCookie(name, '1', -1)
  },
  getUserCookie(name) {
    var arr = document.cookie.replace(/\s/g, '').split('&')
    for (var i = 0; i < arr.length; i++) {
      var tempArr = arr[i].split('=')
      if (tempArr.length >= 2 && tempArr[tempArr.length - 2] === name) {
        return decodeURIComponent(tempArr[tempArr.length - 1])
      }
    }
    return ''
  },
}
